import { FiltersTypes } from "@common/types/filters/general";

export type CustomersFilters = Pick<
    FiltersTypes,
    "customerIds" | "withEmptyCustomer" | "hasCustomer"
>;

export const HAS_BILLABLE_CUSTOMER_LABEL = "Has billable customer";
export const NO_BILLABLE_CUSTOMER_LABEL = "Does not have billable customer";
